"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Actions = require("../actions/Actions");

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var appReducer = function appReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState.default;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _Actions.SET_INSTANCE_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        instanceId: payload.id
      });

    case _Actions.SET_BALANCE_DETAILS:
      return _objectSpread(_objectSpread({}, state), {}, {
        customerBalance: _objectSpread(_objectSpread({}, state.customerBalance), payload)
      });

    case _Actions.GET_BALANCE_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        customerBalance: _objectSpread(_objectSpread({}, state.customerBalance), {}, {
          isFetching: false,
          hasError: false
        })
      });

    case _Actions.GET_BALANCE_DETAILS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        customerBalance: {
          amount: '',
          currency: '',
          isFetching: true,
          hasError: false
        }
      });

    case _Actions.GET_BALANCE_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        customerBalance: {
          hasError: true,
          isFetching: false
        }
      });

    case _Actions.SET_BALANCE_LISTENER_ACTIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        balanceListenerList: payload
      });

    default:
      return state;
  }
};

var _default = appReducer;
exports.default = _default;